import { render, staticRenderFns } from "./Modulinformationen.vue?vue&type=template&id=79b08b29"
import script from "./Modulinformationen.vue?vue&type=script&lang=js"
export * from "./Modulinformationen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports